module.exports = __webpack_public_path__ + "img/question.34cfa896.svg";